import { apiRequest } from "../utils/api";

const getAll = async (params = {}) => {
  const response = await apiRequest.get("/api/prompt-templates", { params });
  return response.data;
};

const getById = async id => {
  const response = await apiRequest.get(`/api/prompt-templates/${id}`);
  return response.data;
};

const create = async data => {
  const response = await apiRequest.post("/api/prompt-templates", data);
  return response.data;
};

const update = async (id, data) => {
  const response = await apiRequest.put(`/api/prompt-templates/${id}`, data);
  return response.data;
};

const remove = async id => {
  const response = await apiRequest.delete(`/api/prompt-templates/${id}`);
  return response.data;
};

const PromptTemplateService = {
  getAll,
  getById,
  create,
  update,
  delete: remove,
};

export default PromptTemplateService;